import config from '@conf'
import { Service } from './service'

export class TransactionsService extends Service {
  /**
   * Loads tx_history for provided token
   * @param tokenCode
   *
   * @return {Promise<object>} - Promise object representing tx history
   */
  loadTransactionHistory (tokenCode, t, hash, number, wallet, from, to) {
    return this._horizonRequestBuilder
    .payments()
    .forAccount(this._accountId)
    .forAsset(tokenCode)
    .order('desc')
    .limit(config.TRANSACTIONS_PER_PAGE)
    .filterType(t)
    .filterHash(hash)
    .filterOrderNumber(Number(number))
    .filterWallet(wallet)
    .filterDateFrom(from)
    .filterDateTo(to)
    .callWithSignature(this._keypair)
  }
}

export const transactionsService = new TransactionsService()



// WEBPACK FOOTER //
// ./src/js/services/transactions.service.js